import { render, staticRenderFns } from "./AvalaibilityDay.vue?vue&type=template&id=18744f06&"
import script from "./AvalaibilityDay.vue?vue&type=script&lang=js&"
export * from "./AvalaibilityDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports